import {
  NBS_WS_GET_TYPING,
  USER_NOT_TYPING
} from '../../constants/actions';

const initialState = {};

export default function userIsTyping (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_WS_GET_TYPING:
      const userTyping = {[`${action.data['user_id']}`]: {isTyping: true, lastTyped: Math.floor(Date.now() / 1000)}};
      return {
        ...state,
        ...userTyping
      };
    case USER_NOT_TYPING:
      const setUserNotTyping = {[`${action.data['user_id']}`]: {isTyping: false}};
      return {
        ...state,
        ...setUserNotTyping
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/userIsTyping.js